module.exports = __webpack_public_path__ + "static/img/logo_beijing.db456255.svg";